<template>
  <div class="table-responsive rounded">
    <table class="table border table-hover rounded" style="min-width: 200%;">
      <thead>
        <tr>
          <th scope="col">Invoice #</th>
          <th scope="col">Tracking #</th>
          <th scope="col">Status</th>
          <th scope="col">Qty</th>
          <th scope="col">Price</th>
          <th scope="col">Shipping</th>
          <th scope="col">Handling</th>
          <th scope="col">Discount</th>
          <th scope="col">Tax</th>
          <th scope="col">Total</th>
          <th scope="col">Date added</th>
          <th scope="col">Cleared</th>
          <th scope="col">&nbsp;</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="invoice in invoices" :key="invoice.inv_id">
          <td>
            <p>{{ invoice.inv_no }}</p>
          </td>
          <td>
            <p>{{ invoice.tracking_no }}</p>
          </td>
          <td>
            <p>{{ invoice.status_value }}</p>
          </td>
          <td>
            <p>{{ invoice.qty }}</p>
          </td>
          <td>
            <p>
              ${{
                invoice.item_prc.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </p>
          </td>
          <td>
            <p>
              ${{
                invoice.shipping.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </p>
          </td>
          <td>
            <p>
              ${{
                invoice.handling.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </p>
          </td>
          <td>
            <p>
              ${{
                invoice.inv_cdisc.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </p>
          </td>
          <td>
            <p>
              ${{
                invoice.item_tax.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </p>
          </td>
          <td>
            <p>
              ${{
                invoice.ext_price.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              }}
            </p>
          </td>
          <td>
            <p>{{ convertToMonthDayYear(invoice.act_date) }}</p>
          </td>
          <td>
            <div class="form-check form-switch">
              <b-form-checkbox switch />
            </div>
          </td>
          <td>
            <input
              type="button"
              class="btn btn-danger btn-sm"
              style="color: white;"
              value="Delete"
              @click="deleteInvoice(invoice.inv_id)"
            />
          </td>
        </tr>

        <!-- New row -->
        <tr>
          <td>
            <input
              type="text"
              class="form-control input-sm"
              v-model="newInvoice.inv_no"
            />
          </td>
          <td>
            <input
              type="text"
              class="form-control input-sm"
              v-model="newInvoice.tracking_no"
            />
          </td>
          <td>
            <select class="form-control input-sm" v-model="newInvoice.status">
              <option value="RWI">RWI</option>
              <option value="SB">SB</option>
              <option value="BOC">Back Ordered</option>
              <option value="REG">Shipped</option>
              <option value="DSR">Drop Ship Released</option>
              <option value="RWO">RWO</option>
            </select>
          </td>
          <td>
            <input
              type="number"
              min="0"
              class="form-control input-sm"
              v-model.number="newInvoice.qty"
            />
          </td>
          <td>
            <input
              type="text"
              class="form-control input-sm"
              v-model.number="newInvoice.item_prc"
            />
          </td>
          <td>
            <input
              type="text"
              class="form-control input-sm"
              v-model.number="newInvoice.shipping"
            />
          </td>
          <td>
            <input
              type="text"
              class="form-control input-sm"
              v-model.number="newInvoice.handling"
            />
          </td>
          <td>
            <input
              type="text"
              class="form-control input-sm"
              v-model.number="newInvoice.inv_cdisc"
            />
          </td>
          <td>
            <input
              type="text"
              class="form-control input-sm"
              v-model.number="newInvoice.item_tax"
            />
          </td>
          <td>
            <input
              type="text"
              class="form-control input-sm"
              v-model.number="newInvoice.ext_price"
            />
          </td>
          <td></td>
          <td>
            <b-form-checkbox switch />
          </td>
          <td>
            <input
              type="button"
              class="btn btn-primary btn-sm"
              value="Add"
              @click="addNewInvoice()"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { convertToMonthDayYear } from "../../../../../../utilities/date";
export default {
  name: "InvoiceTable",
  data() {
    return {
      newInvoice: {
        order_id: null,
        inv_no: "",
        status: "REG",
        qty: 0,
        act_date: "",
        item_prc: 0,
        inv_cdisc: 0,
        item_tax: 0,
        ext_price: 0,
        tracking_no: "",
        shipping: 0,
        handling: 0,
      },
    };
  },
  methods: {
    convertToMonthDayYear,
    addNewInvoice() {
      const date = new Date();
      const stringDate = date.toISOString();

      let newInvoice = this.newInvoice;
      newInvoice.order_id = this.order.orderId;
      newInvoice.act_date = stringDate;

      // adding validations for numbers, negative values etc
      // invoice number is required
      if(!newInvoice.inv_no) throw alert("Invoice number is required.")

      // status is required
      if(!newInvoice.status) throw alert("Status is required.")
      
      // quantity should be a numerical, non-negative, non-deciaml
      if(typeof newInvoice.qty != "number" || newInvoice.qty < 0 || newInvoice.qty % 1 != 0) throw alert("Quantity should be a non-negative and a non-decimal number.")

      // price should be a numerical, non-negative
      if(typeof newInvoice.item_prc != "number" || newInvoice.item_prc < 0) throw alert("Price should be numerical and non-negative.")

      // shopping should be a numerical, non-negative
      if(typeof newInvoice.shipping != "number" || newInvoice.shipping < 0) throw alert("Shopping should be numerical and non-negative.")

      // handling should be a numerical, non-negative
      if(typeof newInvoice.handling != "number" || newInvoice.handling < 0) throw alert("Handling should be numerical and non-negative.")

      // discount should be a numerical, non-negative
      if(typeof newInvoice.inv_cdisc != "number" || newInvoice.inv_cdisc < 0) throw alert("Discount should be numerical and non-negative.")

      // tax should be a numerical, non-negative
      if(typeof newInvoice.item_tax != "number" || newInvoice.item_tax < 0) throw alert("Tax should be numerical and non-negative.")

      // total should be a numerical, non-negative
      if(typeof newInvoice.ext_price != "number" || newInvoice.ext_price < 0) throw alert("Total should be numerical and non-negative.")

      this.$store.dispatch("orderDetails/addInvoice", newInvoice).then(() => {
        this.$store.dispatch("orderDetails/getInvoices", {
          orderId: this.order.orderId,
        });

        // setting newInvoice to default mode
        this.newInvoice = {
          order_id: null,
          inv_no: "",
          status: "REG",
          qty: 0,
          act_date: "",
          item_prc: 0,
          inv_cdisc: 0,
          item_tax: 0,
          ext_price: 0,
          tracking_no: "",
          shipping: 0,
          handling: 0,
        }
      });

      console.log(error);
    },
    deleteInvoice(invoiceId) {
      this.$store
        .dispatch("orderDetails/deleteInvoice", {
          invoiceId,
        })
        .then(() => {
          this.$store.dispatch("orderDetails/getInvoices", {
            orderId: this.order.orderId,
          });
        });
    },
  },
  computed: {
    order() {
      return this.$store.state.orderDetails.orderData;
    },
    invoices() {
      return this.$store.state.orderDetails.invoices;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
  margin-left: -27px;
}
.not-allowed {
  cursor: not-allowed;
}
p {
  margin-bottom: 0;
}
</style>
